(function () {
  var mqDesktop = window.matchMedia('(min-width: 1024px)');
  var SEL = '.product-page-wrapper .product__media-container';

  function syncStableMediaMinHeight(container) {
    var media = container.querySelector('.product__media');
    if (!media) return;

    if (!mqDesktop.matches) {
      media.style.removeProperty('min-height');
      return;
    }

    var cw = media.clientWidth;
    if (!cw) return;

    var maxH = 0;
    container.querySelectorAll('[data-product-media-wrapper]').forEach(function (wrap) {
      var img = wrap.querySelector('img[data-aspectratio]');
      if (img) {
        var ar = parseFloat(img.getAttribute('data-aspectratio'));
        if (ar > 0) maxH = Math.max(maxH, cw / ar);
        return;
      }
      var v = wrap.querySelector('video');
      if (v && v.videoWidth) maxH = Math.max(maxH, (cw * v.videoHeight) / v.videoWidth);
    });

    if (maxH > 0) media.style.minHeight = Math.ceil(maxH) + 'px';
  }

  function syncAllMinHeights() {
    document.querySelectorAll(SEL).forEach(syncStableMediaMinHeight);
  }

  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(syncAllMinHeights, 150);
  });

  window.addEventListener('load', syncAllMinHeights);

  function initProductMediaControls(scope) {
    var root = scope || document;

    root.querySelectorAll(SEL).forEach(function (container) {
      if (container.dataset.mediaControlsBound === 'true') return;

      var controls = container.querySelector('[data-product-media-controls]');
      if (!controls) return;

      var prev = controls.querySelector('[data-product-media-prev]');
      var next = controls.querySelector('[data-product-media-next]');
      var dots = [].slice.call(controls.querySelectorAll('[data-product-media-dot]'));
      var thumbs = [].slice.call(container.querySelectorAll('[data-product-thumbnail]'));
      var ids = dots.map(function (d) {
        return d.dataset.mediaId;
      });
      var section = container.closest('.product');

      if (!prev || !next || !dots.length || !ids.length) return;

      function currentIndex() {
        var t = container.querySelector('[data-product-thumbnail].active');
        if (t) return ids.indexOf(t.dataset.thumbnailId);
        var visible = container.querySelector('[data-product-media-wrapper]:not(.hidden)');
        return visible ? ids.indexOf(visible.dataset.mediaId) : 0;
      }

      function syncState() {
        var i = Math.max(currentIndex(), 0);
        dots.forEach(function (dot, j) {
          dot.classList.toggle('is-selected', j === i);
        });
        prev.disabled = i <= 0;
        next.disabled = i >= ids.length - 1;
      }

      function go(index) {
        if (index < 0 || index >= ids.length) return;
        var id = ids[index];
        var thumb = container.querySelector('[data-thumbnail-id="' + id + '"]');
        if (thumb) thumb.click();
        else if (typeof switchImage === 'function' && section) switchImage(section, id);
        requestAnimationFrame(syncState);
      }

      prev.addEventListener('click', function () {
        go(currentIndex() - 1);
      });
      next.addEventListener('click', function () {
        go(currentIndex() + 1);
      });
      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          go(ids.indexOf(dot.dataset.mediaId));
        });
      });
      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          requestAnimationFrame(syncState);
        });
      });

      document.addEventListener('flu:product:variant-change', function (e) {
        var v = e && e.detail && e.detail.variant;
        if (!v || !v.featured_media) return;
        var ix = ids.indexOf(String(v.featured_media.id));
        if (ix > -1) go(ix);
      });

      syncState();
      syncStableMediaMinHeight(container);
      requestAnimationFrame(function () {
        syncStableMediaMinHeight(container);
      });
      container.dataset.mediaControlsBound = 'true';
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initProductMediaControls(document);
  });

  document.addEventListener('shopify:section:load', function (e) {
    initProductMediaControls(e.target);
  });
})();
